import React from 'react';
import AppRouter from './AppRouter';
import { UserContextProvider } from './context/UserContextProvider';
import { ClientConfigurationContextProvider } from './context/ClientConfigurationContextProvider';
import { AgentAccessContextProvider } from './context/AgentAccessContextProvider';
import GeaoContextProvider from './components/GeaoOnboarding/GeaoContextProvider';

import './styles/styles';

export default function App() {
    return (
        <ClientConfigurationContextProvider>
            <UserContextProvider>
                <AgentAccessContextProvider>
                    <GeaoContextProvider>
                        <AppRouter />
                    </GeaoContextProvider>
                </AgentAccessContextProvider>
            </UserContextProvider>
        </ClientConfigurationContextProvider>
    );
}
